// extracted by mini-css-extract-plugin
module.exports = {"checkbox_checked":"checkbox_checked-lZxNU","checkbox":"checkbox-2yrb4","consents__text":"consents__text-3LDkm"};